import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SimpleModalModule } from '../simple-modal/simple-modal.module';
import { FooterSlimComponent } from './footer-slim.component';

@NgModule({
  declarations: [FooterSlimComponent],
  imports: [CommonModule, SimpleModalModule],
  exports: [FooterSlimComponent]
})
export class FooterSlimModule {}
